<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="item.Id" :label="$t('servicesystem.common_objects.commonterms.id')" disabled>
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ContractTypeSelect v-model="item.ContractTypeId" :externaledit="editMode" :rules="[requiredRule]" hideIcon
          @FocusState="handleFocus">
        </ContractTypeSelect>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.contract.name')"
          :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row style="background-color: #fff2ea;">
      <v-col cols="12">
        <QTextArea v-model="item.ContractComment" :label="$t('servicesystem.common_objects.contract.contract_comment')"
          :backgroundcolor="'#fff2ea'" :externaledit="editMode" @FocusState="handleFocus">
        </QTextArea>
      </v-col>
    </v-row>
    <v-row style="background-color: #edfffd;">
      <v-col cols="12">
        <QTextArea v-model="item.InvoiceComment" :label="$t('servicesystem.common_objects.contract.invoice_comment')"
          :backgroundcolor="'#edfffd'" :externaledit="editMode" @FocusState="handleFocus">
        </QTextArea>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import ContractTypeSelect from '@/components/Inputs/EntityDropdowns/ContractTypeSelect.vue';

export default {
  name: "ContractEditContent",
  props: {
    item: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    ContractTypeSelect,
  },
  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>